import{CustomThemeProperty as e}from"./types.js";var o=e("loadingOverlay",{position:"absolute",bg:"foreground",height:"100%",width:"100%",transition:"base",pointerEvents:"none",zIndex:1,inset:0});export{o as loadingOverlay};
//# sourceMappingURL=loadingOverlay.js.map
